<template>
 <div>
  <div class="logo-container">
    <div class="logo-item logo-shape">
      <img src="@/assets/logo/shape.png" />
    </div>
    <div class="logo-item logo-ring">
      <img src="@/assets/logo/ring.png" />
    </div>
    <div class="logo-item logo-sign">
      <div>
        <div>
          <div class="pl-2 text-left fs-52px name-player border-logo-1">
            CYPRUS
          </div>
          <div class="pl-2 text-left fs-52px name-player border-logo-2">
            CONFIDENTIAL
          </div>
        </div>
      </div>
    </div>
    <div class="logo-item logo-intro">
      <p v-html="$t('appContent.intro')"></p>
      <p v-html="$t('appContent.end_intro')"></p>
    </div>
    <div ref="logo-line" class="logo-item logo-line-down"></div>
  </div>
  <div class="arrow-progress">
    <div ref="progres-bar-nav" class="arrow-money">
      <img class="arrow-img"  src="@/assets/arrow-down-pri.png" />
    </div>
  </div>
 </div>
</template>

<style lang="scss">
  @-moz-keyframes spin { 
    100% { -moz-transform: rotate(360deg); } 
  }
  @-webkit-keyframes spin { 
    100% {
      -webkit-transform: rotate(360deg);
    } 
  }
  @keyframes spin { 
    100% { 
      -webkit-transform: rotate(360deg); 
      transform:rotate(360deg); 
    } 
  }

  @keyframes slideUp { 
    0% { 
      top: 150%;
    } 
    100% { 
      top: 82%;
    } 
  }

  @keyframes slideUp { 
    0% { 
      top: 100%;
    } 
    100% { 
      top: 82%;
    } 
  }

  .logo-container {
    position: relative;
    height: 320px;
    max-width: 320px;
    margin: 50px auto;
    width: 320px;
    margin-bottom: 420px;

    @media(max-width: 720px) {
      width: 100%;
      left: 0 !important;
      margin-bottom: 200px;
    }

    svg{
      width: 100%;
    }
  }
  .logo-item  {
    width: 100%;
    position: absolute;

    img {
      width: 100%;
    }
  }
  .logo-shape  {
    width: 80% !important;
    margin: 10%;
    position: absolute;
  }
  .logo-ring  {
    -webkit-animation:spin 55s linear infinite;
    -moz-animation:spin 55s linear infinite;
    animation:spin 55s linear infinite;
    border-radius: 50%;
  }
  .logo-sign {
    width: 120%;
    left: 55%;
    top: 82%;
    animation: slideUp 3.25s 1;
    font-family: "headline-gothic-atf-rough-n1", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 41px;

    @media(max-width: 720px) {
      width: 100%;
      left: 0 !important;
    }

    .border-logo-1 {
      border-top: solid 4px #000;
    }
    
    .border-logo-2 {
      border-top: solid 1px #000;
    }
  }

  .logo-intro {
    top: 200%;
    left: -25%;
    width: 150%;
    font-size: 26px;
    background-color: rgba(255, 255, 255, 0.894);
    z-index: 2;

    @media(max-width: 720px) {
      top: 150%;
      left: 1px !important;
      width: 105%;
      font-size: 21px;
      text-align: left;
      padding-left: 15px;
    }

    p {
      margin: 35px 0;
    }
  }
  .logo-line-down {
    top: 82%;
    left: 55%;
    width: 1px;
    height: 300%;
    background-color: #000;
    animation: slideUp 3.25s 1;
    transition: height .5s ease-in-out;
    @media(max-width: 720px) {
      left: 0 !important;
    }
  }

  .arrow-progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    

    .arrow-money {
      position: absolute;
      left: calc(50% - 17px);
      width: 75px;
      transition: transform .15s ease-in-out;

      @media(max-width: 720px) {
        left: 10% !important;
        transform: rotate(0) !important;
      }
    }

    img {
      width: 100%;
      transition: transform .15s ease-in-out;
    }
  }
  
  .item-character-list {
    padding: 65px 0;
    margin: 45px 0;

    h3 {
      padding: 0 15px;
    }
    
    h4 {
      padding: 0 15px;
    }

    &.active {
      .text-intro {
        height: 150px;
        padding: 0 15px;

        @media(max-width: 720px) {
          height: 175px;
        }
      }
    }


    .line-vertical-file {
      height: 2px;
      width: 100%;
      background-color: #000;
    }

    .text-intro {
      height: 0;
      overflow: hidden;
      transition: height .65s ease-in-out;

      @media(max-width: 720px) {
        font-size: 17px;
      }
    }
  }
</style>

<script>

  import * as d3 from 'd3'

  export default {
    name: 'logoProgress',
    methods: {
      calcPosition() {
        let wrapper = document.querySelector(`.power_players_wrapper`)
        let scale = d3.scaleLinear().domain([0, wrapper.offsetHeight]).range([0, window.innerHeight])
        
        return `${scale(window.scrollY)}`
      }
    },
    mounted() {

      if(document.querySelector(`.item-character-list`)) {
        let wrapper = document.querySelector(`.power_players_wrapper`)
        let arrow = document.querySelector(`.arrow-money`)
        let arrow_img = document.querySelector(`.arrow-money img`)
        let logo_line = this.$refs['logo-line']
        let offset = window.innerHeight * .35

        arrow.style.top = `${wrapper.offsetTop - (offset)}px`
        logo_line.style.height = `${wrapper.offsetTop - (offset)}px`

        window.addEventListener('scroll', () => {

          if(window.scrollY > wrapper.offsetTop) {

            let items = document.querySelectorAll(`.item-character-list`)

            if(wrapper.offsetTop <= window.scrollY) {
              arrow.style.top = `${window.scrollY-80}px`
              logo_line.style.height = `${window.scrollY-offset}px`
            }
            
    
            let triggers = Array.from(items).map((item, ix) => {
              return {
                start: wrapper.offsetTop + item.offsetTop,
                end: wrapper.offsetTop + item.offsetTop + item.offsetHeight,
                element: item,
                index: ix,
                width: item.offsetWidth,
                position: ix%2==0 ? `left` : `right`
              }
            })
                      
            let fake_y = window.scrollY+(window.innerHeight*.25)

            triggers.forEach(element => {

              if((element.start <= fake_y) && (element.end >=fake_y)) {
                element.element.classList.add(`active`)

                if(element.position == `left`){
                  arrow_img.style.transform = `rotate(45deg)`
                }
                else if(element.position == `right`) {
                  arrow_img.style.transform = `rotate(-45deg)`
                } else {
                  arrow_img.style.transform = `rotate(0)`
                }

              } else {
                element.element.classList.remove(`active`)
              }
    
            });
          }
  
        })
      }

    }
  }

</script>